
import { defineComponent } from 'vue'
import OrangeButton from '@/components/Buttons/OrangeButton.vue'
import { goto } from '@/helpers'

export default defineComponent({
  components: { OrangeButton },
  methods: { goto },
})
